<div class="outer-container">
    <div class="col-3">
        <div class="row h-100">
            <div class="speaking-score-inner-container sparc-title-container text-center col-8 col-md-6">
                <div class="speaking-score-sparc-line mb-0 h4">SPARC</div>
                <div class="speaking-score-long-line h6 mt-2">Speaking
                    Proficiency&nbsp;Score</div>
            </div>
            <div class="speaking-score-inner-container speaking-score-number-container col-4 col-md-6">
                <div class="speaking-score-number-box p-3">
                    <div *ngIf="hasSPARCScore" class="speaking-score-number h1">{{speakingScore.Score}}</div>
                    <h1 *ngIf="!hasSPARCScore" class="speaking-score-text" style="padding-bottom: 0">--</h1>
                    <div *ngIf="speakingScoreIncreased" class="speaking-score-icon ml-md-2"
                        ngbTooltip="Current score is higher than that of the previous unit." placement="end"
                        tooltipClass="custom-tooltip-styling">
                        <i class="fas fa-caret-up h1" style="color: #79C045;"></i>
                    </div>
                    <div *ngIf="speakingScoreDecreased" class="speaking-score-icon ml-md-2"
                        ngbTooltip="Current score is lower than that of the previous unit." placement="end"
                        tooltipClass="custom-tooltip-styling">
                        <i class="fas fa-caret-down h1" style="color: #FD362C;"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="speaking-score-inner-container speaking-score-meter-container col-3">
        <app-speaking-score-meter [min]="speakingScore.ReferenceMinScore" [mid]="speakingScore.ReferenceAverageScore"
            [max]="speakingScore.ReferenceMaxScore" [current]="speakingScore.Score"
            [showPointer]="hasSPARCScore">
        </app-speaking-score-meter>
    </div>
    <div class="speaking-score-inner-container pr-0 col-6">
        <div class="speaking-score-progress-chart-box">
            <canvas *ngIf="hasSPARCProgressData" class="speaking-score-progress-chart" #speakingScoreChart>{{ chart }}</canvas>
            <h6 *ngIf="!hasSPARCProgressData" class="speaking-score-text" style="padding-bottom: 0; width: 100%">
                No speaking data available yet for the current level.<br>Keep using Joy School English to get
                enough speaking opportunities to generate data.
            </h6>
        </div>
    </div>
</div>